export default __webpack_public_path__ + "static/media/file-icon-doc.fa4740ad.svg";